<template>
  <div class="text-left">
    <BreadcrumbsNav />
    <v-row align="center">
      <v-col cols="12" sm="10" class="pb-12">
        <h1 class="text-h4 font-weight-black mb-8">Espace Gestionnaire</h1>
        <p>
          Bienvenue dans l'espace dédié aux gestionnaires ! Retrouvez ici toutes les ressources, conseils et outils pour
          piloter efficacement votre cantine, réaliser des économies et mieux maîtriser le gaspillage alimentaire.
        </p>
      </v-col>
      <v-col cols="2">
        <v-img
          src="/static/images/doodles-dsfr/primary/ReadingDoodle.png"
          v-if="$vuetify.breakpoint.smAndUp"
          class="mx-auto rounded-0"
          contain
          max-width="100%"
        ></v-img>
      </v-col>
    </v-row>
    <!-- Section 1: Analyse en temps réel du gaspillage alimentaire par type de convive -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6" order-md="1" order="2">
        <h2 class="text-h5 font-weight-bold mb-4">
          Analyse en temps réel du gaspillage alimentaire par type de convive
        </h2>
        <p>
          La plateforme intègre une fonctionnalité de saisie (manuelle ou via notre IA Vision) et suivi automatisé du
          gaspillage selon le profil du convive (âge, type de régime, préférences indiquées) afin de croiser ces données
          avec les menus servis. Cela vous permettra de mieux cibler l’origine des déchets et d’adapter en continu
          l’offre alimentaire à la réalité du terrain, allant plus loin que la simple pesée après le service.
        </p>
      </v-col>
      <v-col cols="12" md="6" order-md="2" order="1">
        <v-img
          src="/static/images/peeps-illustration-couple.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
    </v-row>

    <!-- Section 2: Optimiseur Anti-Gaspillage Prédictif -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6">
        <v-img
          src="/static/images/lighthouse.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
      <v-col cols="12" md="6">
        <h2 class="text-h5 font-weight-bold mb-4">Optimiseur Anti-Gaspillage Prédictif</h2>
        <p>
          La loi AGEC fixe une réduction de 50% du gaspillage alimentaire d'ici 2025. Notre IA analyse les données
          historiques de consommation, météo, événements locaux pour prédire précisément les quantités à préparer. Elle
          croise ses données avec la consommation au quotidien (si vous optez pour le module d’analyse continue) de
          chaque convive de manière anonyme (chaque convive peut récupérer ses données pour un suivi personnalisé).
        </p>
      </v-col>
    </v-row>

    <!-- Section 3: Analyseur Nutritionnel Convives Personnalisé -->
    <v-row align="center" class="my-12">
      <v-col cols="12" md="6" order-md="1" order="2">
        <h2 class="text-h5 font-weight-bold mb-4">Analyseur Nutritionnel Convives Personnalisé</h2>
        <p>
          Module d'analyse nutritionnelle qui s'adapte aux profils des convives (âge, allergies, besoins spécifiques).
          Il calcule automatiquement l'équilibre nutritionnel de chaque menu et propose des alternatives pour respecter
          les recommandations PNNS.
          <br />
          Via notre application mobile, une borne ou un mur papier, vous recueillez en direct ou périodiquement les
          retours des convives sur le goût, la quantité, et proposez des mini-sondages de satisfaction. Ces données
          alimentent en aval l’analyse du gaspillage et l’ajustement des recettes, tout en impliquant les usagers dans
          la démarche anti-gaspi.
        </p>
      </v-col>
      <v-col cols="12" md="6" order-md="2" order="1">
        <v-img
          src="/static/images/sitting-person-color.png"
          contain
          max-width="100%"
          class="mx-auto rounded-0 gestionnaire-img"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BreadcrumbsNav from "@/components/BreadcrumbsNav"

export default {
  name: "GestionnairePage",
  components: { BreadcrumbsNav },
}
</script>

<style scoped>
.gestionnaire-img {
  max-height: 400px;
  width: auto;
}
@media (max-width: 600px) {
  .gestionnaire-img {
    max-width: 320px;
    height: auto;
    max-height: none;
  }
}
</style>
